// extracted by mini-css-extract-plugin
export default {"Container":"TopStripe_Container__Lpf+U"};